import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import IpcEquipmentPoolsPredesResdesAnalysisReport from '../../components/IpcEquipmentPoolsPredesResdesAnalysisReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/IpcEquipmentPoolsPredesResdesAnalysisIpcPalletBoxIbSelectors';

export function IpcEquipmentPoolsPredesResdesAnalysisIpcPalletBoxIbContainer(props) {
  return (
    <IpcEquipmentPoolsPredesResdesAnalysisReport
      reportId={ReportDefinitions.IPC_PALLET_BOX_IB_PREDES_RESDES_ANALYSIS.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

IpcEquipmentPoolsPredesResdesAnalysisIpcPalletBoxIbContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(IpcEquipmentPoolsPredesResdesAnalysisIpcPalletBoxIbContainer);
